export default {
    meta: {
        title: '商机管理',
        isShowNav: true,
    },
};
